import { render, staticRenderFns } from "./ContasPagarBaixa.vue?vue&type=template&id=8cb6b532&scoped=true"
import script from "./ContasPagarBaixa.vue?vue&type=script&lang=js"
export * from "./ContasPagarBaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb6b532",
  null
  
)

export default component.exports